import { useConnect } from "wagmi";
import styled from "styled-components";
import CloseImg from "@/assets/svg/close.svg";
import CoinbaseWalletImg from "@/assets/imgs/coinbase.png";
import MetaMaskkImg from "@/assets/imgs/metamask.png";
import WalletConnectImg from "@/assets/imgs/walletconnect.png";
import { ReactSVG } from "react-svg";
import { arbitrumGoerli } from 'wagmi/chains'


export default function Walltes({ handleClose }) {
  const { connect, connectors, error, isLoading, pendingConnector } =
    useConnect({
      chainId: arbitrumGoerli.id,
    });
  return (
    <Modal>
      <div className="close" onClick={handleClose}>
        <ReactSVG src={CloseImg} />
      </div>
      <div className="content">
        <div className="title">Connect Wallet</div>
        <div className="wallet-list">
          {connectors.map((connector) => (
            <div
              className={`btn ${isLoading && connector.id === pendingConnector?.id ? 'btn-loading' : ''}`}
              disabled={!connector.ready}
              key={connector.id}
              onClick={() => connect({ connector })}
            >
              <img className="wallet-logo" src={connector.name === 'MetaMask' ? MetaMaskkImg :(connector.name === 'WalletConnect' ? WalletConnectImg : CoinbaseWalletImg)} alt="" />
              <div className="text">
                {connector.name}                
                {!connector.ready && " (unsupported)"}
              </div>
              <div className="loading-circle">
                {isLoading && connector.id === pendingConnector?.id &&
                  " (connecting)"}
              </div>
            </div>
          ))}
          {/* {error && <div>{error.message}</div>} */}
        </div>
      </div>
    </Modal>
  );
}

const Modal = styled.div`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding-top: 32px;
  position: relative;
  background: #000;
  .close {
    position: absolute;
    right: 35px;
    top: 42px;
    cursor: pointer;
  }
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .title {    
    font-weight: 600;
    font-size: 24px;  
    line-height: 34px;    
    color: #32DE86;
    padding-bottom: 27px;
  }
  .wallet-list {
    display: flex;
    flex-direction: column;
    align-items: center;
    .btn {
      cursor: pointer;
      width: 408px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      box-sizing: border-box;
      background: #fff;
      border-radius: 12px;
      height: 62px;
      line-height: 62px;
      font-weight: 600;
      font-size: 16px;
      color: #232323;
      &.btn-loading{
        background: rgba(255, 255, 255, 0.6);
      }  
      & + .btn {
        margin-top: 20px;
      }
      .wallet-logo {
        width: 41px;
        height: 41px;
        margin-left: 24px;
        margin-right: 15px;
      }
    }
  }
`;
